<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding: 15px"
>

    <!-- SSO Settings Card -->
    <v-card class="mt-6 mb-6" outlined>
        <v-card-title class="grey lighten-4">
            <v-icon left color="primary">mdi-account-key</v-icon>
            Single Sign-On Configuration
        </v-card-title>
        <v-card-text class="pt-4">
            <p class="text-body-2 grey--text text--darken-1 mb-4">
                Configure your organization's SSO settings below.
                Note that when SSO is enabled for an organization, all users belonging to that organization will be required to authenticate through SSO, even if they are members of other organizations that don't use SSO.
                Additionally, enabling SSO for an organization will disable password authentication for those users. 
                If you need to disable SSO for an organization, all users will need to have their passwords reset. Their previous passwords will not work.
            </p>
            
            <v-alert
                v-if="!$rc.$state.isAuthActorSystemAdmin()"
                type="info"
                dense
                text
                class="mb-4"
            >
                <strong>Staff Only:</strong> SSO settings can only be modified by RedChirp system administrators.
            </v-alert>

            <div v-if="$rc.$state.isAuthActorSystemAdmin()">
                <m-settings-organization-sso
                    :organization_id="organization_id"
                />
            </div>
            <div v-else>
                <p class="text-body-2 grey--text">
                    Contact a system administrator to modify SSO settings for this organization.
                </p>
            </div>
        </v-card-text>
    </v-card>



</v-container>
</m-pageframe>
</template>

<script>
import MSettingsOrganizationSSO from './settings-organization-sso.vue';


export default {
    name: 'settings-organization-sso-page',
        components: {
        'm-settings-organization-sso': MSettingsOrganizationSSO
    },
    props: {
        
    },

    data() {
        return {
            //Get organization_id from route params
            organization_id: this.$route.params.organization_id,
        }
    },

    mounted() {
        // Any initialization logic
    },

    computed: {
        title() {
            return "Single Sign-On (SSO) Settings";
        },
    },

    methods: {
        // Add any component-specific methods here
    },
}
</script>

<style lang="scss" scoped>
.v-card-title {
    font-weight: 600;
}

.v-list-item-title {
    font-weight: 500;
}
</style>
